import { LitElement, html, css } from "lit";

// TODO
export class PlayerYT extends LitElement {

    static styles = css`
    *{
        margin : 0;
        padding:  0;
    }
    :host{

    }
    iframe,
    .thumbnail{
        display:flex;
        width:100%; 
        height:auto;
        min-height:260px;
        
    }

    @media (min-width: 992px) {
        iframe,
        .thumbnail{
            aspect-ratio: 16/9;
        }
    }
    .thumbnail{
        position : relative;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        cursor:pointer !important;
    }
    .infos{
        position: absolute;
        padding: 40px;
        bottom: 0;
    }

    .button{
        top: 50%;
        left : 50%;
        transform : translate(-50%, -50%);
        display:flex;
        align-items:center;
        justify-content : center;
        height: 80px;
        width : 80px;
        border-radius : 100%;
        padding: 40px;
        background-color : white;
        position : absolute;
        padding : 1px;
        cursor: pointer;
        }
        .button svg{
            transform : translate(4px,0);
        }
    `


    static properties = {
        title: { type: String },
        src: { type: String },
        subtitle: { type: String },
        thumbnail: { type: String },
        isPlaying: { type: Boolean }
    }

    constructor() {
        super();
        this.isPlaying = false;
    }


    firstUpdated() {
        super.firstUpdated();
        super.connectedCallback()
        var tag = document.createElement('script');
        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        tag.addEventListener('load', () => {
            this.wrapper = this.shadowRoot.querySelector("#player");

        })
    }

    willUpdate(props) {
        if (props.has('isPlaying')) {
            if (this.isPlaying === true) {
                this.createYoutubePlayer()
            } else {
                if(this.player) {
                    this.player.stopVideo()
                    this.player.destroy()
                }
            }
        }
    }

    render() {
        return html`
        <div id="player">
            <div class="thumbnail" @click=${() => this.setIsPlaying(!this.isPlaying)}
                style="background-image:url(${this.thumbnail})" >
                <div class="button">
                    ${this.renderPlay()}
                </div>
                <div class="infos">
                    <h2>${this.title}</h2>
                    <div>${this.subtitle}</div>
                </div>
            </div>
        </div>
        `
    }

    renderPlay() {
        return html`
        <svg xmlns="http://www.w3.org/2000/svg" width="20.593" height="27.236" viewBox="0 0 20.593 27.236">
            <path id="Polygone_2" data-name="Polygone 2"
                d="M12.784,1.261a1,1,0,0,1,1.668,0L26.21,19.041a1,1,0,0,1-.834,1.552H1.86a1,1,0,0,1-.834-1.552Z"
                transform="translate(20.593) rotate(90)" fill="#bfb3aa" />
        </svg>
`
    }
    /**
     * 
     * @param {Boolean} bool 
     */
    setIsPlaying(bool) {
        this.isPlaying = bool;
    }

    createYoutubePlayer() {
        let id = this.getIdFromYoutubeURL(this.src)

        this.player = new YT.Player(this.wrapper, {
            wmode: 'transparent',
            host: 'https://www.youtube-nocookie.com',
            playerVars: {
                wmode: 'transparent',
                showinfo: 0,
                autohide: 1,
            },
            videoId: id,
            events: {
                'onReady': onPlayerReady
            }
        });

        function onPlayerReady(event) {
            event.target.playVideo();
        }

        this.videoIsCreate = true
    }

    getIdFromYoutubeURL(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        var match = url.match(regExp);
        return (match && match[7].length == 11) ? match[7] : false;
    }

}

customElements.define('player-youtube', PlayerYT);